<template>
  <v-card class="login-page d-flex align-center justify-center rounded-0 bg" width="100vw" min-height="100vh"
    height="wrap-content">
    <div class="logo">
      <img src="../../assets/epicor.png" alt="Epicor" />
    </div>

    <div>
      <v-card class="login-card pa-10 d-flex flex-column align-center justify-space-between rounded-xl" width="400px">
        <h3 class="mb-6">
          {{ isLogin ? $t("logIn") : $t("register") }}
        </h3>

        <div class="width-100">
          <v-text-field v-if="!isLogin" v-model.trim="userInput.userName" :label="$t('name')" color="#333333"
            :rules="[rules.required]" class="input-group--focused" />

          <v-text-field v-if="!isLogin" v-model.trim="userInput.userCompany" label="Company" color="#333333"
            :rules="[rules.required]" class="input-group--focused" />

          <v-text-field v-model.trim="userInput.userEmail" label="Email" color="#333333"
            :rules="[rules.required, rules.email]" class="input-group--focused" />

          <v-text-field v-if="!isLogin" v-model.trim="userInput.userPhone" label="Phone" color="#333333"
            :rules="[rules.required]" class="input-group--focused" />

          <v-text-field v-if="isLogin" v-model="userInput.userPassword"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'"
            :label="$t('password')" :hint="$t('hintPasswordField')" color="#333333"
            :rules="[rules.required, rules.passwordMin]" class="input-group--focused"
            @click:append="showPassword = !showPassword" @keyup.enter="handleSubmit" />

          <v-checkbox v-if="!isLogin" v-model="policyChecked" color="green" class="mb-5" light
            :label="'Agree to the all policy of Data V Tech'" />
        </div>

        <v-switch v-model="isTest" style="margin-bottom: 7px; margin-top: 0" hide-details label="Live/Test" />

        <div v-if="errorMessage" class="d-flex justify-start error-text">
          <h5>{{ errorMessage }}</h5>
        </div>

        <g-recaptcha data-sitekey="6LcEqtQlAAAAAGHpVRo-Yb6sVo0o_3fa9jT2qhoP"
          class="input-group--focused width-100 d-flex justify-center" style="width: 100%"
          :data-validate="validateCaptcha" :data-callback="handleCaptchaSuccess">
          <v-btn elevation="2" min-width="150px" class="mb-3 width-100" :loading="loading" :disabled="loading"
            @click="onSubmitClick">
            {{ isLogin ? $t("logIn") : $t("register") }}
          </v-btn>
        </g-recaptcha>

        <a class="switchTabMsg" @click="toggleMode">
          {{ isLogin ? $t("switchTabRegister") : $t("switchTabLogin") }}
        </a>
      </v-card>
    </div>

    <div class="d-flex align-center justify-center direction-column">
      <h4 class="d-flex footer-text">
        &copy; 2023 Developed by Data V Tech Solutions Company Limited
      </h4>
      <a class="d-flex footer-link" href="https://www.datavtech.com">
        www.datavtech.com
      </a>
    </div>
  </v-card>
</template>

<script>
import gRecaptcha from "@finpo/vue2-recaptcha-invisible";
import { mapGetters } from "vuex";
import DecodeJWT from "../DecodeJWT";

export default {
  name: "LoginPage",
  components: {
    gRecaptcha,
  },
  data() {
    return {
      isTest: false,
      isLogin: true,
      showPassword: false,
      policyChecked: false,
      loading: false,
      errorMessage: "",
      userInput: {
        userName: "",
        userPhone: "",
        userEmail: "",
        userCompany: "",
        userPassword: "",
      },
    };
  },
  computed: {
    ...mapGetters("User", ["getToken", "getCase", "getLoginErr", "getIsDone"]),
    rules() {
      return {
        required: (value) => !!value || this.$t("required"),
        email: (value) =>
          /.+@.+\..+/.test(value || "") || "Email is invalid",
        passwordMin: (value) =>
          (value && value.length >= 6) || this.$t("hintPasswordField"),
      };
    },
  },
  watch: {
    isTest: {
      immediate: true,
      handler(value) {
        localStorage.setItem("Test", String(value));
      },
    },

    getIsDone(value) {
      if (value === true) {
        this.loading = false;
        this.$store.dispatch("User/setIsDoneFalse");
      }
    },

    getToken(token) {
      if (!token) {
        this.loading = false;
        return;
      }

      this.handleTokenRedirect(token);
    },

    getLoginErr(value) {
      if (value && value !== 0) {
        this.loading = false;
        this.errorMessage = "Incorrect email or password!";
      }
    },

    getCase(value) {
      if (!value) return;

      this.loading = false;
      alert(
        "Thank you for submitting your registration on our Customer Service Portal. We are pleased to inform you that your registration ticket Number: " +
        value +
        " has been successfully received and is now being processed. Once your registration has been approved, you will receive an email confirmation containing your login details. Thank you for your patience."
      );

      this.resetForm();
      this.isLogin = true;
    },
  },
  mounted() {
    const savedTest = localStorage.getItem("Test");
    if (savedTest !== null) {
      this.isTest = savedTest === "true";
    }

    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const info = DecodeJWT(token);
      const isExpired = !info?.exp || info.exp <= Date.now() / 1000;

      if (!isExpired) {
        this.handleTokenRedirect(token);
      }
    } catch (error) {
      console.error("Invalid token in localStorage:", error);
      localStorage.removeItem("token");
    }
  },
  methods: {
    validateCaptcha() {
      return true;
    },

    onSubmitClick() {
      this.errorMessage = "";
      this.loading = true;
    },

    async handleCaptchaSuccess(token) {
      if (!token) {
        this.loading = false;
        this.errorMessage = "Please check you are not robot!!!";
        return;
      }

      if (this.isLogin) {
        await this.handleLogin();
      } else {
        await this.handleRegister();
      }
    },

    async handleLogin() {
      this.errorMessage = "";

      if (!this.userInput.userEmail || !this.userInput.userPassword) {
        this.loading = false;
        this.errorMessage = "Please enter email and password.";
        return;
      }

      try {
        await this.$store.dispatch("User/login", {
          email: this.userInput.userEmail,
          pass: this.userInput.userPassword,
        });
      } catch (error) {
        console.error("Login error:", error);
        this.loading = false;
        this.errorMessage = "Incorrect email or password!";
      }
    },

    async handleRegister() {
      this.errorMessage = "";

      const { userName, userCompany, userPhone, userEmail } = this.userInput;

      if (!userName || !userCompany || !userPhone || !userEmail) {
        this.loading = false;
        this.errorMessage = "*Please fill in all information.";
        return;
      }

      if (!this.policyChecked) {
        this.loading = false;
        this.errorMessage =
          "*To continue, you must agree to all Data V Tech Policy.";
        return;
      }

      try {
        await this.$store.dispatch("User/register", {
          user: this.userInput,
        });
      } catch (error) {
        console.error("Register error:", error);
        this.loading = false;
        this.errorMessage = "Register failed. Please try again.";
      }
    },

    handleTokenRedirect(token) {
      try {
        const info = DecodeJWT(token);
        const status = info?._user?.status;
        const isExpired = !info?.exp || info.exp <= Date.now() / 1000;

        console.log("Decoded JWT:", info);
        console.log("Status:", status);

        if (isExpired) {
          this.loading = false;
          localStorage.removeItem("token");
          this.$router.push("/login");
          return;
        }

        if (status === 1 || status === 0 || status == "1" || status == "0") {
          this.$store.dispatch("User/updateInfo", { user: info._user });
          this.$store.dispatch("User/DSPGetCompanyInfo");
        }

        this.loading = false;

        if (status === 1 || status == "1") {
          this.$router.push("/home");
        } else if (status === 0 || status == "0") {
          this.$router.push("/ChangePassword");
        } else {
          this.errorMessage = "Incorrect email or password!";
          this.$router.push("/login");
        }
      } catch (error) {
        console.error("Token redirect error:", error);
        this.loading = false;
        localStorage.removeItem("token");
        this.$router.push("/login");
      }
    },

    toggleMode() {
      this.isLogin = !this.isLogin;
      this.errorMessage = "";
      this.resetForm();
    },

    resetForm() {
      this.userInput = {
        userName: "",
        userPhone: "",
        userEmail: "",
        userCompany: "",
        userPassword: "",
      };
      this.policyChecked = false;
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.width-100 {
  width: 100%;
}

.direction-column {
  margin-top: 40px;
  flex-direction: column;
}

.bg {
  flex-direction: column;
  background-color: #006780;
  background-size: cover;
}

.login-page {
  position: relative;
  padding: 24px;
}

.login-card {
  background-color: rgba(255, 255, 255, 1);
  height: auto;
}

.logo {
  margin-bottom: 24px;
}

.logo img {
  max-width: 180px;
  height: auto;
}

.hidden {
  display: none !important;
}

a:hover {
  font-weight: bolder;
}

.switchTabMsg {
  text-align: center;
  width: fit-content;
  color: black !important;
  text-decoration: underline;
  cursor: pointer;
}

.passwordRules {
  margin-top: -25px;
  margin-left: 15px;
  font-size: small;
  opacity: 0.6;
}

.error-text {
  width: 100%;
  color: red;
  margin-bottom: 12px;
}

.footer-text {
  color: white;
}

.footer-link {
  color: white;
  text-decoration: underline;
}
</style>